import { useState } from "react"
import { Outlet } from "react-router-dom"
import { Menu } from "lucide-react"
import DashboardNav from "./dashboard-nav"
import { ModeToggle } from "@/components/mode-toggle"
import { UserNav } from "@/components/user-nav"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { usePageBasedApiLoader } from "@/hooks/use-page-based-api-loader"

export default function DashboardLayout() {
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  usePageBasedApiLoader()

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="px-3 md:px-6 flex h-14 items-center">
          <div className="mr-4 hidden md:flex">
            <h1 className="text-xl font-bold">Admin Dashboard</h1>
          </div>

          {/* Mobile menu button */}
          <Sheet open={isMobileOpen} onOpenChange={setIsMobileOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 md:hidden"
              >
                <Menu className="h-5 w-5" />
                <span className="sr-only">Toggle Menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="pr-0">
              <div className="">
                <h1 className="text-xl font-bold">Admin Dashboard</h1>
              </div>
              <div className="my-4 h-[calc(100vh-8rem)]">
                <DashboardNav closeSheet={() => setIsMobileOpen(false)} />
              </div>
            </SheetContent>
          </Sheet>

          <div className="flex flex-1 items-center justify-between space-x-2 md:justify-end">
            <div className="w-full flex-1 md:w-auto md:flex-none">
              <h1 className="text-xl font-bold md:hidden">Admin Dashboard</h1>
            </div>
            <nav className="flex items-center space-x-2">
              <ModeToggle />
              <UserNav />
            </nav>
          </div>
        </div>
      </header>

      <div className="mx-auto w-full max-w-screen-2xl items-start md:grid md:grid-cols-[200px_minmax(0,1fr)] md:gap-6 lg:gap-10 px-3 md:px-6">
        {/* Sidebar */}
        <aside className="fixed top-14 z-30 hidden h-[calc(100vh-3.5rem)] w-[200px] shrink-0 md:sticky md:block">
          <div className="h-full py-6 pr-6 lg:py-8">
            <DashboardNav />
          </div>
        </aside>

        {/* Main content */}
        <main className="flex w-full flex-col overflow-hidden">
          <div className="py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
